export const actionType = {
  actionItem: 'actionItem',
  docusign: 'docusign',
  survey: 'survey',
  skillsChecklist: 'skillsChecklist',
  missingInformation: 'missingInformation',
};
export enum actionItemTypeId {
  HealthcareLicensure = 2,
  NursingCertifications = 3,
  StateDriversLicense = 4,
  StrikePhysicalExam = 12,
  StrikeUploadMmrvVaccination = 14,
  StrikeUploadHealthcareLicensure = 18,
  StrikeUploadBlsAclsPalsOrNrp = 19,
  StrikeWiselyPayCardNonExistingPayCardHolder = 20,
  StrikeWiselyPayCardExistingPayCardHolder = 20,
  VirtualInterview = 25,
  UpdateEmergencyContact = 29,
  UpdateCurrentAddress = 30,
  CovidBoosterEligible = 31,
  HandbookAcknowledgement = 6,
  MedicalRecordsReleaseStatement = 7,
  CovidSymptomScreeningForm = 8,
  StrikeConfirmation = 21,
  CovidReligiousAccommodationRequest = 24,
  Covid19VaccinationCard = 5,
  StrikeUploadInfluenzaVaccination = 13,
  StrikeUploadTuberculosisTest = 15,
  StrikeUploadTdapVaccination = 16,
  StrikeUploadFitTest = 17,
  CovidVaccinationTrainingModules = 10,
  BackgroundCheckAuthorization = 1,
  OnlineKnowledgeTesting = 9,
  StrikeBackgroundCheckInitialization = 11,
  OnlineKnowledgeTestingStrike = 23,
  Survey = 26,
  Docusign = 27,
  SkillsChecklist = 28,
  UpdateJobPreferences = 32,
  ConfirmyourTravelItinerary = 33,
  SkillsChecklistUpdateRequest = 34,
  StrikeEducationUpdateRequest = 35,
  WorkHistoryExperienceUpdateRequest = 36,
  WorkHistoryGapUpdate = 37,
  PayTransparencyDataCollection = 38,
  LicenseUpdate = 39,
  CertificationsUpdate = 40,
  //This id will change in Api connector story
  OngoingStrikeApply = 46,
}
